import { type Ref } from "vue";
import { tween } from "../animation/tween";

export type UseTweeenedNumberProps = {
  value: Ref<number>;
  duration?: number;
}



export const useTweenedNumber = (props: UseTweeenedNumberProps) => {
  return tween(props.value, {
    duration: props.duration
  });
}
